const customerLogos = [
    {
      customer: "Innova Salud",
      path: "https://storage.googleapis.com/b000004/$2a$08$iFgOf4xg19MZd6BRcjieX9gvcNxN3heqKKzyqKCsYZz65beI3iO"
    },
    {
      customer: "Odonto King",
      path: "https://storage.googleapis.com/b000004/$2a$08$TsMstwu3yfyP6b5Qu310QeQdRg8pop4udAF4BIbocUQk0oDkr0jO"
    },
    {
      customer: "Happy Dent",
      path: "https://storage.googleapis.com/b000004/$2a$08$Af9GBx4VXSdVgbVao6qEOmxPEoLsxq1mKBpI2IBAxedK4ZmQhP"
    },
    {
      customer: "BioZone",
      path: "https://storage.googleapis.com/b000004/$2a$08$jACbufSmLjirRgAH3I0Gu6xQQHjIv0iHBAJgMmc3JBH6zRWmAOK"
    },
    {
      customer: "Paola Mendoza",
      path: "https://storage.googleapis.com/b000004/$2a$08$YE8mxUVtuTfeqKueEo1NfRCbNuwuTzzTSzQUTY3tWV7RZJ5wPi"
    },
    {
      customer: "Dr. Diego Murillo",
      path: "https://storage.googleapis.com/b000004/$2a$08$EoB6OSwUNYu2VyBZfUvQjOdY7nGFMj9RSJKVa8Tb6JyTtNRTDlG5y"
    },
    {
      customer: "RIO",
      path: "https://storage.googleapis.com/b000004/$2a$08$YWiDqnTRuFKxPKcHuwmnVuw1Lu2qx8Wq7riNDJlF0o1cWPym5UxT2"
    },
    {
      customer: "FAITHMED",
      path: "https://storage.googleapis.com/b000004/$2a$08$FyWGtMYhHyj7v5hWnIVSeg26AuajlkEuKyFt8wYP0nIGbGoT6aNu"
    },
    {
      customer: "INNOVA",
      path: "https://storage.googleapis.com/b000004/$2a$08$Ls52ogVNVwi7e0RojzzNOnkMGQR3fG5jDVX7965jshF4CLR3uFe"
    },
    {
      customer: "IPODA",
      path: "https://storage.googleapis.com/b000004/$2a$08$FUrEOhu1BKbEDdDIBhKlOqZ6lMOtWU1exEQl93PFcmS5oLf9eFI"
    },
    {
      customer: "simetria",
      path: "https://storage.googleapis.com/b000004/$2a$08$a3Wv6pXIkn0y3KFpvZcexQzBsgWn2RSPPjNMEZ3nIgW3ZrYwqy"
    },
    // {
    //   customer: "Dr. Yuri Mollinedo",
    //   path: ""
    // },
    {
      customer: "SPAZIO",
      path: "https://storage.googleapis.com/b000004/$2a$08$GdKqLwpqkTzZVLtbxMaOsMcsyGSQPiMAmxr2PXVEvOtJp0jZDm"
    },
    // {
    //   customer: "CAPILEA",
    //   path: ""
    // },
    // {
    //   customer: "ameleLP",
    //   path: ""
    // },
    {
      customer: "Clinica Dental Suarez",
      path: "https://storage.googleapis.com/b000004/$2a$08$1lUWPYGRhyEBAZ7AqOeIuXLOCCtRjfzPUyiuixYf7gkcr6eW78e"
    },
    {
      customer: "Clinica Madrid",
      path: "https://storage.googleapis.com/b000004/$2a$08$hDDDubI2rZjZwus3DpEAiSdIbZW39Gr0EsGUXSfKublwpz9m3W"
    },
    {
      customer: "Dra Angela Madrid",
      path: "https://storage.googleapis.com/b000004/$2a$08$zLcWw4Ft2gTdKDKS0Bu6zenSuIxjJ8R9blTXrOZ6kOmlYH0gKDxK"
    },
    {
      customer: "Dr Marcelo Torrez",
      path: "https://storage.googleapis.com/b000004/$2a$08$HplMD8MslicNVIT00BGvtezrj22AgZYoBJnAAqS9dR3jbfMcVdW"
    },
    // {
    //   customer: "PsicoMed",
    //   path: ""
    // },
    {
      customer: "OncoDiagnostic",
      path: "https://storage.googleapis.com/b000004/$2a$08$eD8C46GGALyfyYoodyHhAQlTTUpQ2jthTmJluBs5ueh5hAQ7e"
    },
    {
      customer: "Dr Lijeron",
      path: "https://storage.googleapis.com/b000004/$2a$08$KhiyYKs0hQgAP192CHC0KeS5a3H4ikpGG7n5OmFwft03bxROda"
    },
    {
      customer: "Dra Paola Antelo",
      path: "https://storage.googleapis.com/b000004/$2a$08$07J97rF5YvhNf91vI3AZiuqll8m2rQ9KOtBcJrgOJDIT4GtfamvS"
    },
    {
      customer: "Dra Gabriela Perez",
      path: "https://storage.googleapis.com/b000004/$2a$08$Gqkywh8AYa5JfQLg9XuvZuZtTXeg5qooqRdipLUG5CD8twXSRS"
    },
    {
      customer: "Dr Laguna",
      path: "https://storage.googleapis.com/b000004/$2a$08$pRczg5vZySTw6gzAdNR6eeWbwwoZhS0vviVYOOISIpaslQ9xXZhC"
    },
    // {
    //   customer: "OBE",
    //   path: "https://storage.googleapis.com/b000004/$2a$08$b7CGSkexVHNLJvOtQ34HQ0CL01DpBwolXJmTshhXkQDgoNKou76y"
    // },
    {
      customer: "Fernanda Lima",
      path: "https://storage.googleapis.com/b000004/$2a$08$9VVACYuIJuuW1XPKfoBDgOxjsvFk7b1cIYdtMRp2FIzMCE2EntWiy"
    },
    {
      customer: "BiodentAll",
      path: "https://storage.googleapis.com/b000004/$2a$08$b7CGSkexVHNLJvOtQ34HQ0CL01DpBwolXJmTshhXkQDgoNKou76y"
    },
    {
      customer: "Odonto Queen",
      path: "https://storage.googleapis.com/b000004/$2a$08$hOnOMC0eglCXWB09X67cwuZtTkmqao8Bwl4wYQxteSPn69urfIyLq"
    },
    {
      customer: "Dra Tatiana Escalera",
      path: "https://storage.googleapis.com/b000004/$2a$08$Tmkwz4W0FGOmwHLTls5NHuX1nQavd7jQec5kPxSxrF3JsGo6yXNN2"
    },
    // {
    //   customer: "NovaHair",
    //   path: ""
    // },
    {
      customer: "ROI",
      path: "https://storage.googleapis.com/b000004/$2a$08$59coUiz6aFB32IKItSPXOKktKMU8LTthYWTP946VCY84o9yDtcK"
    },
    {
      customer: "Clinica Valor",
      path: "https://storage.googleapis.com/b000004/$2a$08$8o3tiAXoDhou8NjoJsRuObDpmOniycmvHUadZjXPJMjjSzQ4pi"
    },
    {
      customer: "DENTALCOR",
      path: "https://storage.googleapis.com/b000004/$2a$08$7y8vnAZNp2PthVO0ABlrKh3URYlONBWm2MSgUGS3fCQkkc9Oy"
    },
    // {
    //   customer: "Dra. Claudia Ayala",
    //   path: ""
    // },
    {
      customer: "Centro de Vacunacion",
      path: "https://storage.googleapis.com/b000004/$2a$08$Qpay6WVJsX1NyoTcjmVjie5WhWHCxeZ2zQpAG27NIKSOW4tLgRsb6"
    }
    // {
    //   customer: "Dentalcor",
    //   path: "https://storage.googleapis.com/b000004/$2a$08$7y8vnAZNp2PthVO0ABlrKh3URYlONBWm2MSgUGS3fCQkkc9Oy"
    // }
    // {
    //   customer: "Policia Boliviana",
    //   path: ""
    // },
    // {
    //   customer: "Dr.Igor Toco",
    //   path: ""
    // },
    // {
    //   customer: "FMEC",
    //   path: ""
    // },
    // {
    //   customer: "Medicos Voluntarios",
    //   path: ""
    // },
  ];

export default customerLogos;